module.exports = __webpack_public_path__ + "img/pdf.3644ac69.svg";